import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";

export default function Layout() {
  return (
    <SmoothScroll>
      <div className="min-h-screen flex flex-col bg-black">
        <Header />
        <main className="flex-1 pt-[104px]">
          <Outlet />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
